var _effectorFileName = "/builds/gmini/front-utils/src/awaitFirst.ts";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { watchOnce } from './watchOnce';
export var awaitFirst = function awaitFirst(event) {
  return new Promise(function (resolve) {
    return watchOnce(resolve, event);
  });
};